// extracted by mini-css-extract-plugin
export var sliderRange = "_qb-2";
export var sliderRoot = "_qb-0";
export var sliderThumb = "_qb-3";
export var sliderTrack = "_qb-1";